<template>
    <div class="nasabah">
        <p class="title">
            Nasabah Baru
        </p>
        <div class="content">
            <b-tabs>
                <!-- Render Tabs, supply a unique `key` to each tab -->
                <b-tab title="Approval List" @click="changeData('Approval')" v-if="checkAccess('approve-document')"> </b-tab>
                <div v-else>
                    <b-tab title="Add Demo List" @click="changeData('Demo')"> </b-tab>
                    <b-tab title="Add Real List" @click="changeData('Real')"> </b-tab>
                    <b-tab title="Waiting for Deposit" @click="changeData('Deposit')"> </b-tab>
                    <b-tab title="Acceptance proof" @click="changeData('Acceptance')"> </b-tab>
                </div>
            </b-tabs>

            <!-- ======Data Nasaabah Baru====== -->
            <div class="tab-contents mt-4">
                <div>
                    <div class="table-responsive">
                        <table ref="example1" class="table table-striped table-bordered" id="new-table">
                            <thead class="text-center text-bold">
                                <tr>
                                    <th>No</th>
                                    <th>Nama Lengkap</th>
                                    <!-- <th v-show="value == 'Demo'">Username</th> -->
                                    <th>Email</th>
                                    <th>
                                        Platform
                                        <div class="form-group mb-0">
                                            <select name="" id="" v-model="platform" @change="filterPlatform">
                                                <option value="">All</option>
                                                <option v-for="(data, i) in dataPlatform" :key="i" :value="data.code">{{ data.name }}</option>
                                            </select>
                                        </div>
                                    </th>
                                    <th>No Telepon</th>
                                    <th v-show="value == 'Real'">No KTP</th>
                                    <th v-show="value == 'Real'">NPWP</th>
                                    <th v-show="value == 'Demo'">Tanggal Pendaftaran</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="count_data > 0">
                                <td colspan="10" v-show="loadingData" style="text-align: center">
                                    <div class="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </td>
                                <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false">
                                    <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                                    <td>{{ data.fullname }}</td>
                                    <td>
                                        <span v-if="value == 'Demo'">{{ data.email }}</span>
                                        <span v-else>{{ data.user.email }}</span>
                                    </td>
                                    <td>
                                        <div v-for="platformData in data.platform" :key="platformData.code">
                                            {{ "- " + platformData.name }}
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="value == 'Demo'">{{ data.phonenumber }}</span>
                                        <span v-else> {{ data.user.phonenumber }}</span>
                                    </td>
                                    <td v-show="value == 'Real'">{{ data.ktp_no }}</td>
                                    <td v-show="value == 'Real'">{{ data.npwp_no }}</td>
                                    <td v-show="value == 'Demo'">{{ data.updated_at | formatDateTime }}</td>
                                    <td>
                                        <div v-if="value == 'Demo'">
                                            <button type="button" class="buttons btn-primary btn-xs" @click="sendId(data, data.platform, 'addAccount')">
                                                Tambah Akun
                                            </button>
                                        </div>
                                        <div v-else-if="data.status == 5">
                                            <button type="button" class="buttons btn-primary btn-xs" @click="sendId(data, data.platform, 'uploadSend')">
                                                Bukti Kirim
                                            </button>
                                            <router-link :to="'/nsb-detail/' + data._id" v-if="checkAccess('get-detail')"
                                                ><button type="button" class="buttons btn-info btn-xs">
                                                    Detail
                                                </button></router-link
                                            >
                                        </div>
                                        <div v-else-if="data.status === 3">
                                            <router-link :to="'/nsb-detail/' + data._id" v-if="checkAccess('get-detail')"
                                                ><button type="button" class="buttons btn-info btn-xs">
                                                    Detail
                                                </button></router-link
                                            >
                                        </div>
                                        <div class="waiting-cimb" v-else>
                                            <router-link :to="'/nsb-detail/' + data._id" v-if="checkAccess('get-detail')"
                                                ><button type="button" class="buttons btn-info btn-xs">
                                                    Detail
                                                </button></router-link
                                            >

                                            <button
                                                type="button"
                                                class="buttons btn-primary btn-xs"
                                                @click="sendData(data._id, data.fullname, data.platform, 'addAccountReal')"
                                                v-if="value == 'Real'"
                                            >
                                                Tambah Akun
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="10" style="text-align: center">
                                        No Data
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="count_data"
                            :per-page="perPage"
                            @change="handlePageChange"
                            aria-controls="new-table"
                            v-show="count_data > perPage"
                        ></b-pagination>
                    </div>
                </div>
            </div>
            <b-modal ref="addAccount" title="Tambah Akun Nasabah">
                <form action="">
                    <div v-for="(dataInput, i) in selectedPlatform" :key="i" class="mb-5">
                        <p>
                            <b>Platform {{ dataInput.name }}</b>
                        </p>
                        <div class="form-group">
                            <label for="">Username</label>
                            <input type="text" class="form-input" placeholder="input user id" v-model="formUsername[i]" @keydown.space.prevent />
                        </div>
                        <div class="form-group">
                            <label for="">Password</label>
                            <input :type="type" class="form-input" placeholder="input password" v-model="formPassword[i]" @keydown.space.prevent />
                            <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="showEye"></b-icon>
                            <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="showEye"></b-icon>
                        </div>
                        <div v-if="selectedPlatform.length == 2">
                            <button type="button" class="btn btn-primer" @click="addDoubleAccount(dataInput.code, formUsername[i], formPassword[i], 'user')">
                                <div v-show="!isLoading">Submit</div>
                                <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                            </button>
                        </div>
                    </div>
                </form>
                <template #modal-footer v-if="selectedPlatform.length != 2">
                    <button class="btn btn-scondary" @click="hideModal('addAccount')" v-show="!isLoading">
                        Cancel
                    </button>
                    <button class="btn btn-primer" @click="addDemoAccount">
                        <div v-show="!isLoading">Submit</div>
                        <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                    </button>
                </template>
            </b-modal>
            <b-modal ref="addAccountReal" title="Verifikasi Nasabah">
                <div class="d-block">
                    <form v-for="(data, i) in selectedPlatform" :key="i" class="mb-5">
                        <p>
                            <b>Platform {{ data.name }}</b>
                        </p>
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-input" v-model="formApprove.username[i]" />
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input :type="type" class="form-input" v-model="formApprove.password[i]" />
                            <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="showEye"></b-icon>
                            <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="showEye"></b-icon>
                        </div>
                        <div v-if="selectedPlatform.length == 2">
                            <button
                                type="button"
                                class="btn btn-primer"
                                @click="addDoubleAccount(data.code, formApprove.username[i], formApprove.password[i], 'customer')"
                            >
                                <div v-show="!isLoading">Submit</div>
                                <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                            </button>
                        </div>
                    </form>
                </div>
                <template #modal-footer v-if="selectedPlatform.length != 2">
                    <button class="btn btn-scondary" @click="hideModal('addAccountReal')" v-show="!isLoading">
                        Cancel
                    </button>
                    <button class="btn btn-primer" @click="sendApprove">
                        <div v-show="!isLoading">Submit</div>
                        <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                    </button>
                </template>
            </b-modal>
            <b-modal ref="uploadSend" title="Upload bukti kirim">
                <form action="">
                    <div class="form-group">
                        <label for="">Ekspedisi</label>
                        <input type="text" placeholder="Input ekspedisi" class="form-input" v-model="formReceipt.expedition" />
                    </div>
                    <div class="form-group">
                        <label for="">Serial Number</label>
                        <input type="text" placeholder="input serial number" class="form-input" v-model="formReceipt.tracking_number" />
                    </div>
                    <div class="form-group">
                        <label for="">Bukti Kirim</label>
                        <input type="file" ref="uploadReceipt" accept="image/jpeg,image/png" @change="onfileReceipt" />
                    </div>
                </form>
                <template #modal-footer>
                    <button class="btn btn-scondary" @click="hideModal('uploadSend')" v-show="!isLoading">
                        Cancel
                    </button>
                    <button class="btn btn-primer" @click="sendReceipt">
                        <div v-show="!isLoading">Submit</div>
                        <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                    </button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { connect, createLocalVideoTrack } from "twilio-video";
import { required, minLength } from "vuelidate/lib/validators";

// import Loading from "../../assets/Loading.vue";

export default {
    components: {
        // Loading,
    },
    data() {
        return {
            tabs: {
                0: "Demo",
                1: "Real",
                2: "Approval",
            },
            dataNsb: [],
            id: "",
            dataApprove: {
                ac_cimb: "",
                ac_cimb_kinesis: "",
                ac_giropos: "",
                ac_abx: "",
                ac_kinesis: "",
                nasabah_id: "",
            },
            isAccess: false,
            currentPage: 1,
            perPage: 10,
            lengthData: "",
            schedule: "",
            status: "",
            room_name: "",
            isLoading: false,
            description: "",
            value: "",
            loadingData: false,
            bank_type: "",
            platform: "",
            count_data: "",
            message: "",
            fullname: "",
            role: "",
            selected: false,
            type: "password",
            idUser: "",
            dataPlatform: [],
            selectedPlatform: [],
            formUsername: [],
            formPassword: [],
            form: {
                username: "",
                password: "",
                user_id: "",
                platform_code: "",
            },
            formApprove: {
                username: [],
                password: [],
            },
            formReceipt: {
                expedition: "",
                tracking_number: "",
                delivery_receipt_file: "",
            },
        };
    },
    validations: {
        description: {
            required,
            minLength: minLength(30),
        },
        form: {
            username: {
                required,
            },
            password: {
                required,
                minLength: minLength(8),
            },
        },

        formUsername: {
            $each: {
                required,
            },
        },

        formPassword: {
            $each: {
                required,
                minLength: minLength(8),
            },
        },
    },
    async mounted() {
        axios.get("/v2/master_data/platform").then((res) => {
            this.dataPlatform = res.data.data;
        });
        this.role = localStorage.getItem("role");
        if (this.checkAccess("approve-document")) {
            this.value = "Approval";
        } else {
            this.value = "Demo";
        }
        this.getData(this.value, this.currentPage, this.platform);
    },
    methods: {
        onfileReceipt() {
            let file = this.$refs.uploadReceipt.files[0];
            this.requestFormData(file).then((res) => {
                this.formReceipt.delivery_receipt_file = res.data.data;
            });
        },
        async requestFormData(file) {
            let formData = new FormData();
            formData.append("file", file);
            return axios.post("/v2/admin-broker/kyc/upload/" + this.idUser, formData);
        },
        checkAccess(value) {
            let service_access = localStorage.getItem("access");
            let dataAcces = JSON.parse(service_access);
            let returnValue = this.isAccess;
            for (let i = 0; i < dataAcces.length; i++) {
                let access = dataAcces[i].access;
                for (let j = 0; j < access.length; j++) {
                    if (access[j] == value) {
                        returnValue = true;
                    }
                }
            }
            return returnValue;
        },
        showEye() {
            if (this.type == "password") {
                this.type = "text";
                this.selected = !this.selected;
            } else {
                this.type = "password";
                this.selected = !this.selected;
            }
        },
        changeData(value) {
            this.value = value;
            this.platform = "";
            if (value == "Demo") {
                this.getData(value, 1, this.platform);
            } else {
                this.getData(value, 1, this.platform);
            }
        },
        filterPlatform() {
            this.getData(this.value, this.currentPage, this.platform);
        },
        handlePageChange(value) {
            this.getData(this.value, value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        async getData(status_nasabah, offset, platform) {
            let url;
            this.value = status_nasabah;
            let setPage = (offset - 1) * this.perPage;
            let role = localStorage.getItem("role");
            let urlAdmin;
            if (role == "0") {
                urlAdmin = "superadmin";
            } else {
                urlAdmin = "admin-broker";
            }
            if (status_nasabah == "Demo") {
                url = "/v2/" + urlAdmin + "/user?offset=" + setPage + "&limit=" + this.perPage + "&platform_code=" + platform;
            } else if (status_nasabah == "Deposit") {
                url = "/v2/" + urlAdmin + "/kyc/customers?status=3&limit=" + this.perPage + "&offset=" + setPage + "&platform_code=" + platform;
            } else if (status_nasabah == "Acceptance") {
                url = "/v2/" + urlAdmin + "/kyc/customers?status=5&limit=" + this.perPage + "&offset=" + setPage + "&platform_code=" + platform;
            } else {
                if (this.checkAccess("approve-document")) {
                    url = "/v2/" + urlAdmin + "/kyc/customers?status=2&limit=" + this.perPage + "&offset=" + setPage + "&platform_code=" + platform;
                } else {
                    url = "/v2/" + urlAdmin + "/kyc/customers?status=4&limit=" + this.perPage + "&offset=" + setPage + "&platform_code=" + platform;
                }
            }
            this.loadingData = true;
            await axios
                .get(url)
                .then((res) => {
                    if (status_nasabah == "Demo") {
                        this.dataNsb = res.data.data.users;
                    } else {
                        this.dataNsb = res.data.data.customers;
                    }
                    this.count_data = res.data.data.total;
                    this.loadingData = false;
                })
                .catch((error) => {
                    this.loadingData = false;
                    console.log(error);
                });
        },
        sendData(id, name, platform, idModal) {
            this.id = id;
            this.fullname = name;
            this.$refs[idModal].show();
            this.description = "";
            this.selectedPlatform = platform;
        },
        hideModal(idModal) {
            this.$refs[idModal].hide();
        },
        sendId(data, code, idModal) {
            this.$refs[idModal].show();
            this.id = data._id;
            if (data.user) {
                this.idUser = data.user._id;
            }
            // this.form.platform_code = code;
            this.selectedPlatform = code;
            this.form.user_id = data._id;
        },
        acceptVideo() {
            axios
                .put("/v1/counter/customer/approve_video_call", {
                    nasabah_id: this.id,
                })
                .then((res) => {
                    if (res.status == 200) {
                        this.$notify({
                            group: "foo",
                            title: "<h5>Video Berhasil diterima</h5>",
                            type: "success",
                        });
                        location.reload();
                    }
                });
        },
        addDemoAccount() {
            this.isLoading = true;
            this.$v.formUsername.$touch();
            this.$v.formPassword.$touch();
            if (this.$v.formUsername.$invalid && this.$v.formPassword.$invalid) {
                return;
            }

            let data = {
                user_id: this.id,
                platform_code: this.selectedPlatform[0].code,
                username: this.formUsername[0],
                password: this.formPassword[0],
            };
            axios
                .post("/v2/admin-broker/user/demoAccount", data)
                .then((res) => {
                    let id_activity = res.data.data.activity_id;
                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.$toast.success("Demo akun berhasil ditambahkan");
                        this.isLoading = false;

                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });

                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$toast.error("Maaf ada kesalahan");
                });
        },
        sendReceipt() {
            this.isLoading = true;
            axios
                .put("/v2/admin-broker/kyc/acceptance-proof/" + this.id, this.formReceipt)
                .then((res) => {
                    if (!res.data.iserror) {
                        this.$toast.success(res.data.message);
                        let id_activity = res.data.data.activity_id;
                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message);
                });
        },
        addDoubleAccount(platform, username, password, role) {
            this.isLoading = true;
            let dataUser = {
                user_id: this.id,
                platform_code: platform,
                username: username,
                password: password,
            };

            let dataCustomer = {
                username: username,
                password: password,
                platform_code: platform,
            };

            let title;
            let method;

            if (role == "user") {
                method = {
                    method: "post",
                    url: "/v2/admin-broker/user/demoAccount",
                    data: dataUser,
                };
                title = "Demo Akun Berhasil Ditambah";
            } else {
                method = {
                    method: "put",
                    url: "/v2/admin-broker/kyc/approve/" + this.id,
                    data: dataCustomer,
                };
                title = "Nasabah berhasil diterima ";
            }
            axios(method).then((res) => {
                let id_activity = res.data.data.activity_id;
                let status = res.data.data.status_code;
                if (status == "00") {
                    this.$store.dispatch("getLocation").then((resGeo) => {
                        let info;
                        if (resGeo.cityData[0]) {
                            info = resGeo;
                        } else {
                            let data = resGeo;
                            data.newLatLong = resGeo.cityLatLong.split(",");
                            info = data;
                        }
                        axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                    });
                    this.isLoading = false;
                    this.$notify({
                        group: "foo",
                        title: title,
                        type: "success",
                        duration: 2000,
                    });
                }
            });
        },

        sendBagi() {
            let api_url;
            if (this.bank_type === "BAGI") {
                api_url = "/v1/nasabah/approve/bagi/" + this.id;
                this.sendBAGI(api_url);
            } else {
                api_url = "/v1/nasabah/approve/cimb/" + this.id;
                this.sendBAGI(api_url);
            }
        },
        sendApprove() {
            this.isLoading = true;
            let data = {
                username: this.formApprove.username[0],
                password: this.formApprove.password[0],
                platform_code: this.selectedPlatform[0].code,
            };
            if (data.username && data.password) {
                axios
                    .put("/v2/admin-broker/kyc/approve/" + this.id, data)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        let id_activity = res.data.data.activity_id;
                        if (status == "00") {
                            this.$notify({
                                group: "foo",
                                title: "<h5>Nasabah berhasil diterima</h5>",
                                type: "success",
                                duration: 2000,
                            });
                            this.$store.dispatch("getLocation").then((resGeo) => {
                                let info;
                                if (resGeo.cityData[0]) {
                                    info = resGeo;
                                } else {
                                    let data = resGeo;
                                    data.newLatLong = resGeo.cityLatLong.split(",");
                                    info = data;
                                }
                                axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                            });
                            setTimeout(function() {
                                location.reload();
                            }, 2000);
                            this.isLoading = false;
                        }
                    })
                    .catch((error) => {
                        this.message = error.response.data.message;
                        let errorMsg = error.response.data.data.err_message;
                        let status_code = error.response.data.data.status_code;
                        this.$toast.error(status_code + " - " + errorMsg);
                        this.isLoading = false;
                    });
            } else {
                this.$toast.error("form belum diisi");
                this.isLoading = false;
            }
        },
        reject() {
            this.$v.description.$touch();
            if (this.$v.description.$error) {
                return;
            }
            this.isLoading = true;
            axios
                .put("/v2/admin-broker/kyc/reject/" + this.id, {
                    description: this.description,
                })
                .then((res) => {
                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5> Nasabah Baru berhasil Ditolak </h5>",
                            type: "success",
                            duration: 2000,
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    } else if (status == 2011) {
                        this.isLoading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5> Nasabah Baru tidak valid </h5>",
                            type: "error",
                            duration: 2000,
                        });
                    }
                });
        },
        createRoom() {
            this.isLoading = true;
            axios
                .put("v1/counter/add_video", {
                    nasabah_id: this.id,
                    video_link: "Nasabah-" + this.room_name,
                    video_schedule: this.schedule,
                })
                .then((resp) => {
                    if (resp.data.status == 200) {
                        this.status = 201;
                        this.isLoading = false;
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        connectTwilio(id, room_name) {
            axios.get(`v1/counter/get/twilio_token?identity=${id}`).then((res) => {
                let token = res.data.data.token;
                connect(token, { video: 350, name: room_name, audio: true }).then((room) => {
                    room.once("participantDisconnected", (participant) => {
                        room.disconnect();
                        var div = document.getElementById(participant.sid);
                        div.remove();
                    });
                    room.on("disconnected", (room) => {
                        // Detach the local media elements
                        room.localParticipant.tracks.forEach((publication) => {
                            publication.track.stop();
                            const attachedElements = publication.track.detach();
                            attachedElements.forEach((element) => element.remove());
                        });
                    });
                });
            });
        },
        leaveRoom() {
            // console.log(this.idRoom)
            this.status = 100;
            if (this.activeRoom) {
                this.activeRoom.disconnect();
            }
            this.roomName.stop();
            this.roomName.detach();
            document.getElementById("liveVideo").innerHTML = "";
            this.activeRoom.localParticipant.tracks.forEach((publication) => {
                document.getElementById("participant").innerHTML = "";
                const attachedElements = publication.track.detach();
                attachedElements.forEach((element) => element.remove());
            });
        },
        videoReview(room_name, id, id_room) {
            this.room_name = id_room;
            this.dataApprove.nasabah_id = id;
            this.id = id;
            axios
                .get("v1/user/video/" + room_name)
                .then((resp) => {
                    if (resp.status == 200) {
                        this.status = resp.status;
                        var token;

                        axios.get(`v1/counter/get/twilio_token?identity=${id}`).then((resp) => {
                            token = resp.data.data.token;
                            document.getElementById("participant").innerHTML = "";
                            connect(token, {
                                video: { width: 350 },
                                name: room_name,
                                audio: true,
                            }).then((room) => {
                                this.activeRoom = room;

                                createLocalVideoTrack().then((track) => {
                                    this.roomName = track;
                                    if (this.activeRoom.state != "disconnected") {
                                        const localMediaContainer = document.getElementById("liveVideo");
                                        const data = localMediaContainer.appendChild(track.attach());
                                        data.style.width = "351px";
                                    } else {
                                        document.getElementById("liveVideo").innerHTML = "";
                                        track.stop();
                                    }
                                });

                                room.on("participantConnected", (participant) => {
                                    participant.tracks.forEach((publication) => {
                                        if (publication.isSubscribed) {
                                            const track = publication.track;
                                            const data = document.getElementById("participant").appendChild(track.attach());
                                            data.style.width = "351px";
                                        }
                                    });

                                    participant.on("trackSubscribed", (track) => {
                                        const data = document.getElementById("participant").appendChild(track.attach());
                                        data.style.width = "351px";
                                    });
                                });

                                room.participants.forEach((participant) => {
                                    participant.tracks.forEach((publication) => {
                                        if (publication.track) {
                                            const data = document.getElementById("participant").appendChild(publication.track.attach());
                                            data.style.width = "351px";
                                        }
                                    });

                                    participant.on("trackSubscribed", (track) => {
                                        const data = document.getElementById("participant").appendChild(track.attach());
                                        data.style.width = "351px";
                                    });
                                });

                                room.on("disconnected", (room) => {
                                    // Detach the local media elements
                                    room.localParticipant.tracks.forEach((publication) => {
                                        const attachedElements = publication.track.detach();
                                        attachedElements.forEach((element) => element.remove());
                                        // document.getElementById('participant').removeChild()
                                    });
                                });

                                // When a Participant removes a Track, detach it from the DOM.
                                room.on("trackRemoved", function(tracks) {
                                    tracks.forEach((track) => {
                                        track.detach().forEach((detachedElement) => {
                                            detachedElement.remove();
                                        });
                                    });
                                });
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.status = error.response.status;
                });
        },
        isNumber(event) {
            // console.log(this.$v.form.phone_number)
            const pattern = /[0-9]/;

            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        rows() {
            return this.dataNsb.length;
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var like = this;

            like.resultCount = this.dataNsb.length;
            if (this.currentPage >= this.totalPages) {
                like.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.icon-eye {
    position: absolute;
    font-size: 26px;
    right: 0.7rem;
    top: 2.25rem;
    color: #707070;
}

.total-user {
    position: relative;
    right: -82%;
    top: 1rem;
    font-weight: bold;
    cursor: pointer;
}

.lds-ring {
    display: inline-block;
    /* position: absolute; */
    width: 30px;
    height: 30px;
    /* top: 4px; */
    /* left: 39%; */
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 6px;
    border: 6px solid #1f354a;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.waiting-cimb {
    font-size: 13px;
    /* background: yellow; */
    padding: 10px 15px;
    text-align: center;
    border-radius: 5px;
    color: #e1161b;
    font-weight: bold;
}

table {
    color: #707070 !important;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 30px;
}

.form-video label {
    display: inline-block;
    width: 50%;
}

.btn {
    margin: 0 10px;
    width: 130px;
    height: 40px;
}

.sub-title-modal {
    text-align: center;
    font-size: 20px;
    /* font-weight: bold; */
}

.create-room {
    cursor: pointer;
    background: #ffc107;
    padding: 7px 15px;
    border-radius: 10px;
}

.minimal {
    font-size: 12px;
}

.wrap-video {
    display: flex;
    justify-content: space-between;
}

#liveVideo,
#participant,
video {
    width: 370px;
    border: solid 1px #dddddd;
    min-height: 306px;
    padding: 7px;
}

#liveVideo + video {
    width: 370px;
}

#participant + video {
    width: 370px;
}

.acecpted-nassabah {
    text-align: center;
    font-size: 18px;
}

.btn-acepted {
    background: rgb(28, 179, 23);
    border-radius: 10px;
    margin: 0 10px;
    color: white;
    padding: 5px 25px;
}

.btn-reject {
    background: rgb(240, 31, 31);
    border-radius: 10px;
    margin: 0 10px;
    color: white;
    padding: 5px 25px;
}

.link-expired {
    text-align: center;
}

.link-expired p {
    font-size: 20px;
    font-weight: bold;
}

.btn-centering {
    text-align: center;
    margin: 0 auto;
    line-height: 2.9;
}

label {
    display: block;
}

.form-input {
    height: 40px;
    width: 100%;
    color: #101010;
}

a {
    color: #999;
}
.current {
    color: red;
}
ul {
    padding: 0;
    list-style-type: none;
}
li {
    display: inline;
    margin: 5px 5px;
}

a.first::after {
    content: "...";
}

a.last::before {
    content: "...";
}
</style>
